import Styles from './ProgressBar.module.scss'

interface ProgressBarProps {
  progress: number
}

export const ProgressBar = ({ progress }: ProgressBarProps) => {
  return (
    <div className={Styles.progressBarContainer}>
      <div
        className={Styles.progressBar}
        data-testid="media-file-progress-bar"
        style={{
          width: `${progress || 0}%`,
          borderRadius: progress > 96 ? '11px' : undefined,
        }}
      />
    </div>
  )
}
